var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('form',[_c('vue-form-generator',{attrs:{"schema":_vm.schema,"model":_vm.model,"options":_vm.formOptions},on:{"model-updated":_vm.modelUpdated,"field-updated":_vm.submitField,"collection-updated":_vm.submitCollection}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }